const codes = {
  error: {
    API_REQUEST_FAILED: 'api-request-failed',
    APP_STATE_ERROR: 'app-state-error',
    VALUE_ERROR: 'value-error',
    TYPE_ERROR: 'type-error',
  }
}

export default codes